import { useState } from 'react';
import { Alert, Button, Spinner, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PageHeading } from '../components/common/PageHeading';
import { RegisterForm } from '../components/register/RegisterForm';
import { ResendEmailForm } from '../components/register/ResendEmailForm';
import { CsvImport } from '../components/register/CsvImport';
import { get } from '../lib/api';
import { usePageTitle } from '../lib/usePageTitle';

export function RegisterUserPage() {
    const { t } = useTranslation();
    usePageTitle(t('register.title'));
    const [syncMsg, setSyncMsg] = useState('');
    const [syncing, setSyncing] = useState(false);

    async function sync24() {
        setSyncing(true);
        setSyncMsg('');
        try {
            const res = await get('home/syncCustomers');
            setSyncMsg(res.status === 200 ? t('sync24.synced') : t('sync24.failed'));
        } catch {
            setSyncMsg(t('sync24.failed'));
        } finally {
            setSyncing(false);
        }
    }

    return (
        <>
            <PageHeading title={t('register.title')} />
            <Tabs defaultActiveKey="register" id="register-tabs" className="mb-2">
                <Tab eventKey="register" title={t('register.tabRegister')}>
                    <RegisterForm />
                </Tab>
                <Tab eventKey="import" title={t('register.tabImport')}>
                    <CsvImport />
                </Tab>
                <Tab eventKey="resend" title={t('register.tabResend')}>
                    <ResendEmailForm />
                </Tab>
                <Tab eventKey="sync" title={t('register.tab24Seven')}>
                    <div className="pt-3" style={{ maxWidth: '34rem' }}>
                        <p className="text-body-secondary">{t('sync24.description')}</p>
                        {syncMsg && (
                            <Alert variant="info" dismissible onClose={() => setSyncMsg('')}>
                                {syncMsg}
                            </Alert>
                        )}
                        <Button variant="primary" type="button" onClick={sync24} disabled={syncing}>
                            {syncing && (
                                <Spinner as="span" size="sm" animation="border" role="status" aria-hidden="true" className="me-2" />
                            )}
                            {t('sync24.sync')}
                        </Button>
                    </div>
                </Tab>
            </Tabs>
        </>
    );
}
